module.exports = __webpack_public_path__ + "static/media/iloj_badge.75f0ec67.png";